module.exports = {
  api: {
    url: "http://api.rootdomain.com:3001",
    ws_url: "ws://api.rootdomain.com:3001/cable",
    responseType: "json",
    timeout: 20000,
    withCredentials: true,
  },
  cookie: {
    secure: false,
    subDomain: "fee.rootdomain.com",
    domainRegex: ".rootdomain.com",
    accountsDomain: "accounts.rootdomain.com:3000",
    homeDomain: "http://www.rootdomain.com:3007",
    ibWebDomain: "http://www.rootdomain.com:3006",
  },
  qbankURL: "http://qbank.rootdomain.com:3005",
  accountsURL: "http://www.rootdomain.com:3000",
  razorPayPublicKey: "rzp_test_zKmV77ODFn4C7c",
};
